import React from 'react';
import {twMerge} from 'tailwind-merge';

import {type SettingType} from '../../../../services/analytics/workspaceSettingsEvents';
import {type LinePlotSettings} from '../types';
import {NumberInput} from './NumberInput';

export const NumberRangeInput = ({
  clearValue,
  minField,
  maxField,
  minValue,
  maxValue,
  updateSetting,
  trackSetting,
}: {
  clearValue?: null;
  minField: 'xAxisMin' | 'yAxisMin';
  maxField: 'xAxisMax' | 'yAxisMax';
  minValue: number | undefined;
  maxValue: number | undefined;
  updateSetting: (settings: Partial<LinePlotSettings>) => void;
  trackSetting: (setting: SettingType, value: string | undefined) => void;
}) => {
  return (
    <div className={twMerge('flex gap-8')}>
      <NumberInput
        clearValue={clearValue}
        placeholder="Min"
        value={minValue}
        updateSetting={(newVal?: number | null) => {
          updateSetting({[minField]: newVal});
          trackSetting(minField, newVal?.toString());
        }}
      />
      <NumberInput
        clearValue={clearValue}
        placeholder="Max"
        value={maxValue}
        updateSetting={(newVal?: number | null) => {
          updateSetting({[maxField]: newVal});
          trackSetting(maxField, newVal?.toString());
        }}
      />
    </div>
  );
};
